import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import TableAHSF from "../../../Components/TableAHSF";
import PopupAHSF from "../../../Components/PopupAHSF";
import { SetArrayDataCheckBoks } from "../../../Redux/Reducers/Shared/CheckBox";
import { encryptToken } from "../../../Services/Encryption/EncryptionParams";

const AllApplicationRequest = () => {
  const dispatch = useDispatch();
  const [popUpBodyStatus, setPopUpBodyStatus] = useState(false);

  const navigate = useNavigate();
  const culomEdite = ["email", "fullName"];
  const staticKeyEdite = ["userGUID", "ssoguid", "lastUpdate"];

  const RequestAccessor = [
    {
      KeyName: "applicationNumber",
      ShowStatus: true,
      NmaeColumn: "رقم الطلب",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "applicationNumber",
        keyValueName: "aI_ApplicationInformationId",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "fieldName",
      ShowStatus: true,
      NmaeColumn: "الحقل",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "applicantsName",
        keyValueName: "aI_ApplicationInformationId",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "applicantsName",
      ShowStatus: true,
      NmaeColumn: "اسم المتقدم",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "applicantsName",
        keyValueName: "aI_ApplicationInformationId",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },

    {
      KeyName: "foundationName",
      ShowStatus: true,
      NmaeColumn: "اسم المؤسسة",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "applicantsName",
        keyValueName: "aI_ApplicationInformationId",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },

    {
      KeyName: "projectName",
      ShowStatus: true,
      NmaeColumn: "اسم المشروع",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "projectName",
        keyValueName: "aI_ApplicationInformationId",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "flowName",
      ShowStatus: true,
      NmaeColumn: "المرحلة الحالية",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "projectName",
        keyValueName: "aI_ApplicationInformationId",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "currentAction",
      ShowStatus: true,
      NmaeColumn: "الاجراء النهائي ",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "projectName",
        keyValueName: "aI_ApplicationInformationId",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    }
  ];
  const RequestsManagerBtns = [
    // {
    //   Click: async (e) => {
    //     // setSecondarySectorsId(e.target.value);
    //     localStorage.setItem(
    //       "aI_ApplicationInformationId_Manager",
    //       e.target.value
    //     );
    //     navigate("/grants/manager/SingleTaskManager");
    //   },
    //   content: "",
    //   className: "bi bi-pencil-square",
    //   id: "editBtn",
    //   title: "عرض",
    //   ShowStatus: true,
    // },
    {
      Click: async (e) => {
        navigate("/SRFund/manager/AllTasks/" + e.target.value);
      },
      content: "",
      className: "bi bi-view-list",
      id: "editBtn",
      title: "عرض",
      ShowStatus: true,
    },
    {
      Click: async (e) => {
        console.log(e.target.value,"ssssssssssssdwd");
        
  //       navigate("/SRFund/manager/AllTasks/" + e.target.value);



  let token = encryptToken(e.target.value);
                     window.open(
                       `/SRFund/manager/MainResearcherInformainContainer/` + token,
                       "_blank"
                     );

      },
      content: "",
      className: "bi bi-eye-fill",
      id: "editBtn",
      title: "عرض",
      ShowStatus: true,
    },
  ];

  const RequestsManagerColumns = [];
  // send to read props popup
  const PopupOPjectData = {
    isPopupOpenStatus: popUpBodyStatus,

    isPopupOpenFunction: () => {},
    componentBody: <div></div>,

    title: "",
    maxWidth: "40%",
    maxHeight: "40%",
    idssss: "SecondarySectors",
  };

  const closePopUp = () => {
    setPopUpBodyStatus(false);
  };

  const popUpBody = {
    isPopupOpenStatus: popUpBodyStatus,
    isPopupOpenFunction: () => {
      setPopUpBodyStatus(false);
    },

    componentBody: <div></div>,

    title: "",
    maxWidth: "40%",
    maxHeight: "40%",
    idssss: "SecondarySectors",
  };

  const shouldDisableFields = "";
  useEffect(() => {
    dispatch(SetArrayDataCheckBoks());
  }, []);
  return (
    <>
      <TableAHSF
        culomEdite={culomEdite}
        uniqueValue={"aI_ApplicationInformationId"}
        valueButtonAction={"aI_ApplicationInformationId"}
        URL={`api/AllApplications/GetAllApplicationInformation`}
        // UrlBody={{
        //   aI_ApplicationInformationId: localStorage.getItem(
        //     "aI_ApplicationInformationId"
        //   ),
        // }}
        staticKeyEdite={staticKeyEdite}
        accessor={RequestAccessor}
        titelTable={"الطلبات"}
        selectRowNumber={true}
        checkBoksColumName="اختيار"
        sort={true}
        pagination={true}
        AppStatus={true}
        tableBtn={false}
        sortTable={true}
        keyNameSort={"dateCreate"}
        dateKey="dateCreate"
        dateformat="DD/MM/YYYY h:mm a"
        arrayNameSort={["applicationNumber"]}
        search={true}
        openPopupState={false}
        DropdownArrayFiltration={[]}
        DropdownFiltration={false}
        exportData={true}
        checkBoks={false}
        nameColumAction=""
        total={false}
        arrayButton={RequestsManagerBtns}
        ArrayNameDataColum={RequestsManagerColumns}
        columnKeyNameArray={[
          { keyName: "applicationNumber", nameColimn: " رقم الطلب" },
        ]}
        PopupOPjectData={PopupOPjectData}
        popUpTitle={"معلومات الطلب"}
        popUpBody={
          <PopupAHSF
            idssss="SecondarySectors"
            isPopupOpenStatus={popUpBody.isPopupOpenStatus}
            isPopupOpenFunction={popUpBody.isPopupOpenFunction}
            title={popUpBody.title}
            componentBody={popUpBody.componentBody}
            maxWidth={popUpBody.maxWidth}
            maxHeight={popUpBody.maxHeight}
          />
        }
      />
    </>
  );
};

export default AllApplicationRequest;
